import { render, staticRenderFns } from "./SideModal.vue?vue&type=template&id=50648390&scoped=true&"
import script from "./SideModal.vue?vue&type=script&lang=ts&"
export * from "./SideModal.vue?vue&type=script&lang=ts&"
import style0 from "./SideModal.vue?vue&type=style&index=0&id=50648390&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50648390",
  null
  
)

export default component.exports